<template>
    <div class="setup-account">
        <div class="security-question">
            <div class="setup">
                <div class="expired">
                    <p>
                        <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
                    </p>
                    <p>A verification link has been sent to <strong>{{ email }}</strong></p>
                </div>
            </div>
        </div>
        <loading ref="loading"></loading>
        <notify ref="notify"></notify>
    </div>
</template>
<style scoped>
    .expired {
        width: 400px;
    }
    .expired p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .broken {
        width: 400px;
    }
    .broken p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .security-question .setup .form div {
        margin-bottom: 0;
    }
    .setup-account {
        height: 100%;
    }
    .security-question {
        height: 100%;
    }
    .question {
        margin-bottom: 1em !important;
    }
    .question label {
        font-weight: normal !important;
        margin-bottom: 0 !important;
    }
</style>

<script>
import loading from '@/components/Loading'
import notify from '@/components/Notify'
export default {
  components: {
    loading,
    notify
  },
  data () {
    return {
      error: {
        answer: false
      },
      email: ''
    }
  },
  mounted () {
    this.email = this.$route.query.email
  }
}
</script>
